import { sprintf } from 'sprintf-js';
import { apiInstance } from 'api/utils';
import { SearchParamsType } from 'api/types';

const URLS = {
  GET_PROJECTS: '/org/%s/admin/projects/',
  GET_PROJECT: '/org/%s/admin/projects/%s/',
  SHARE_WITH_USER: '/org/%s/admin/projects/%s/share_with_user/',
  UNSHARE_WITH_USER: '/org/%s/admin/projects/%s/unshare_with_user/',
  SHARE_WITH_GROUP: '/org/%s/admin/projects/%s/share_with_group/',
  UNSHARE_WITH_GROUP: '/org/%s/admin/projects/%s/unshare_with_group/',
};

export const organizationProjects = {
  getProjects: ({
    organizationCodename,
    params,
  }: {
    organizationCodename: string;
    params?: SearchParamsType;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.GET_PROJECTS, organizationCodename),
      params: {
        ...params,
      },
    }),

  getProject: ({
    organizationCodename,
    id,
  }: {
    organizationCodename: string;
    id: string;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.GET_PROJECT, organizationCodename, id),
    }),
  shareProjectWithUser: ({
    organizationCodename,
    id,
    userId,
  }: {
    organizationCodename: string;
    id: number | string;
    userId: number;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.SHARE_WITH_USER, organizationCodename, id),
      data: {
        id: userId,
      },
    }),
  unshareProjectWithUser: ({
    organizationCodename,
    id,
    userId,
  }: {
    organizationCodename: string;
    id: number | string;
    userId: number;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.UNSHARE_WITH_USER, organizationCodename, id),
      data: {
        id: userId,
      },
    }),
  shareProjectWithGroup: ({
    organizationCodename,
    id,
    userId,
  }: {
    organizationCodename: string;
    id: number | string;
    userId: number;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.SHARE_WITH_GROUP, organizationCodename, id),
      data: {
        id: userId,
      },
    }),
  unshareProjectWithGroup: ({
    organizationCodename,
    id,
    userId,
  }: {
    organizationCodename: string;
    id: number | string;
    userId: number;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.UNSHARE_WITH_GROUP, organizationCodename, id),
      data: {
        id: userId,
      },
    }),
};
